/*
Componente de interfaz gráfica para implementar el Nit y dígito de verificación. 
Recibe el valor del nit vía props.
Al especificar un Nit de 9 dígitos, calcula el dígito de verificación y lo muestra.
Devuelve el Nit y dígito de verificación a través de la función onChange.
*/
import React from "react";
import { useState, useEffect } from "react";

function CampoNit(props) {

    const [valorNit, setValorNit] = useState(props.valor);
    const [digitoVerificacion, setDigitoVerificacion] = useState();
    let anchoValor = props.anchoValor ? props.anchoValor : '66';
    let anchoDigito = props.anchoDigito ? props.anchoDigito : '33';
    let digito = props.digitoVerificacion ? props.digitoVerificacion : '';

    const handleValorNit = (nit) => {

        setValorNit(nit);
        let dv = calcularDigitoVerificacion(nit);
        setDigitoVerificacion(dv);
        props.onChange(nit, dv);
    }

    useEffect(() => {
        let dv = props.valor != null ? calcularDigitoVerificacion(props.valor) : '';
        setDigitoVerificacion(dv);
    }, [props.valor]);


    return <div style={{ display: 'flex' }}>
        <div className="form-group" style={{ width: anchoValor + '%' }}>
            <label htmlFor="numeroDocumento">NIT/Documento</label>
            <input type="text" name="numeroDocumento" className="form-control" id="numeroDocumento" defaultValue={props.valor} onChange={(e) => handleValorNit(e.target.value)} />
        </div>
        <div className="form-group" style={{ width: anchoDigito + '%' }}>
            <label htmlFor="digitoVerificacion">DV</label>
            <input type="text" name="company-address" className="form-control" id="digitoVerificacion" value={digitoVerificacion} style={{ textAlign: 'center' }} />
        </div>
    </div>
}
export default CampoNit;


function calcularDigitoVerificacion(nit) {

    let n1 = parseInt(nit[0]);
    let n2 = parseInt(nit[1]);
    let n3 = parseInt(nit[2]);
    let n4 = parseInt(nit[3]);
    let n5 = parseInt(nit[4]);
    let n6 = parseInt(nit[5]);
    let n7 = parseInt(nit[6]);
    let n8 = parseInt(nit[7]);
    let n9 = parseInt(nit[8]);

    let sumatoria = n1 * 41 + n2 * 37 + n3 * 29 + n4 * 23 + n5 * 19 + n6 * 17 + n7 * 13 + n8 * 7 + n9 * 3;
    let mod = sumatoria % 11;
    let dv = mod;

    if (mod > 1) {
        dv = 11 - mod;
    }

    if (isNaN(dv)) {
        return '';
    }
    else {
        return dv;
    }
}